import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useLocation, useNavigate} from 'react-router-dom';
import ButtonAction from '../ButtonAction';
import HelloUsername from '../HelloUsername';
import {useGlobalContext} from '../../core/GlobalContext';
import {pathnames as P} from '../../../enums';
import logo from '../../../assets/logo.png';
import styles from './TopBar.module.scss';

const TopBar = () => {
  const navigate = useNavigate();
  const {goBackToOldApp, showGoBackToOldAppButton, supportMeteor} = useGlobalContext();
  const goHome = () => navigate(P.HOME);
  const location = useLocation();
  const hideBackButtonLocations = [
    P.AUTH,
    P.LOGOUT,
    P.LOGIN,
    P.LOGIN_BY_PHONE,
    P.LOGIN_AS_ADMIN,
    P.FORGOT_PASSWORD,
    P.UPDATE_PASSWORD,
    P.REGISTER,
    P.HOME
  ];
  const hideBackButton = hideBackButtonLocations.includes(location.pathname) || location.pathname.includes('/paypalPaymentStatus');

  return (
    <div className={styles.topBarContainer}>
      {(showGoBackToOldAppButton && !hideBackButton) && (
        <ButtonAction
          variant={'link'}
          label={
            <FormattedMessage
              id={'button-label-back-to-user-page'}
              defaultMessage={'Return'}
            />
          }
          customClassnames={{
            container: styles.mobileButtonBackContainer,
            label: styles.backButtonLabel
          }}
          onClick={goBackToOldApp}
        />
      )}
      {(!supportMeteor && !hideBackButton) && (
        <ButtonAction
          variant={'link'}
          label={
            <FormattedMessage
              id={'button-label-back-to-user-page'}
              defaultMessage={'Return'}
            />
          }
          customClassnames={{
            container: styles.mobileButtonBackContainer,
            label: styles.backButtonLabel
          }}
          onClick={goHome}
        />
      )}
      <HelloUsername/>
      <img src={logo} alt="Azmai logo" className={styles.logo}/>
    </div>
  );
};

export default TopBar;
